<script>
import isNull from 'lodash/isNull'

export default {
  props: {
    imageUrl: {
      type: String,
      default: '',
      require: false,
    },
    imageBinary: {
      type: String,
      default: '',
      require: false,
    },
    disabled: {
      type: Boolean,
      default: false,
      require: false,
    },
  },
  data() {
    return {
      inValidFileUpload: null,
      uploadFileFeedBack: '',
      placeholder: this.$t('common.upload_image'),
    }
  },
  computed: {
    isValidate() {
      if (isNull(this.inValidFileUpload)) {
        return ''
      }
      return 'is-valid'
    },
  },
  methods: {
    handleUploadFile(files, event) {
      this.uploadFileFeedBack = ''
      this.inValidFileUpload = null
      this.$emit('upload:reset')
      if (!files[0]) {
        return
      }
      const reader = new FileReader()
      reader.readAsDataURL(files[0])
      const self = this
      const fileName = files[0].name
      const ext = /\.(?:(jpg)|(png)|(gif))$/g
      if (!fileName?.toLowerCase().match(ext)) {
        this.uploadFileFeedBack =
          'JPG/GIF/PNG形式のファイルを選択してください。'
        this.inValidFileUpload = false
        event.target.value = '' // clear file
        return
      }
      if (files[0].size > 1048576) {
        this.uploadFileFeedBack = '1MB以下のファイルを選択してください。'
        this.inValidFileUpload = false
        event.target.value = '' // clear file
        return
      }
      reader.onloadend = function() {
        const imgObj = new Image()
        imgObj.onload = function() {
          const imgWidth = imgObj.width
          const imgHeight = imgObj.height
          const imgTmp = imgWidth / imgHeight
          if (imgTmp < 1 || imgTmp > 3.2) {
            self.uploadFileFeedBack =
              '縦横幅比が1.0から3.2の間の画像を指定して下さい(横幅÷縦幅)。'
            self.inValidFileUpload = false
            return
          }
          self.placeholder = files[0].name
          self.$emit('change', reader.result)
          event.target.value = '' // clear file
        }
        imgObj.src = reader.result
        self.uploadFileFeedBack = ''
        self.inValidFileUpload = null
      }
    },
    resetFile() {
      this.$emit('change', '')
      this.placeholder = this.$t('common.upload_image')
    },
  },
}
</script>

<template>
  <div class="d-flex align-items-baseline flex-wrap">
    <CInputFile
      :disabled="disabled"
      v-bind="$attrs"
      :class="['mr-3 flex-1 w-auto', !inValidFileUpload ? 'mb-4' : 'mb-3']"
      custom
      :[isValidate]="inValidFileUpload"
      :invalid-feedback="uploadFileFeedBack"
      add-label-classes="text-truncate"
      :placeholder="!!imageUrl ? ' ' : placeholder"
      accept="image/*"
      @change="handleUploadFile"
    />
    <div>
      <CButton
        v-if="(!!imageUrl || !!imageBinary) && !disabled"
        color="dark"
        variant="outline"
        class="mt-1 py-0"
        @click="resetFile"
      >
        クリア
      </CButton>
    </div>
  </div>
</template>
